import { render, staticRenderFns } from "./FuncionarioCadastro.vue?vue&type=template&id=53516a79"
import script from "./FuncionarioCadastro.vue?vue&type=script&lang=js"
export * from "./FuncionarioCadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports